export default __webpack_public_path__ + "static/media/about.f8ce3272.md";